export default "/images/recruit-direct-access.webp?7ca42e1ad582c37df1a57258e72e854c";